import { Component } from '@angular/core';
import { BUTTON_STYLES } from '../../constants/constants';
import { CookiesService } from '../../services/cookies.service';
import { LocalStorageService } from '../../services/local-storage.service';

@Component({
  selector: 'app-cookies-consent',
  templateUrl: './cookies-consent.component.html',
  styleUrls: ['./cookies-consent.component.scss'],
})
export class CookiesConsentComponent {
  protected readonly BUTTON_STYLES = BUTTON_STYLES;

  constructor(
    private cookiesService: CookiesService,
    private localStorage: LocalStorageService
  ) {
    const { canUseCookies } = this.localStorage.getInfo();

    if (canUseCookies !== undefined) {
      if (canUseCookies) {
        this.allowCookies();
      } else {
        this.denyCookies();
      }
    }
  }

  allowCookies(): void {
    this.cookiesService.allowCookies();
  }

  denyCookies(): void {
    this.cookiesService.denyCookies();
  }
}
